import { editCardModalStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { css } from "styled-components";

editCardModalStyles.postalCodeGridItem = {
    width: [4, 6, 4, 4, 4],
    css: css`
        padding: 10px 8px 10px 10px;
    `,
};
